import { render, staticRenderFns } from "./_tabCompanions.vue?vue&type=template&id=d35a2900&"
import script from "./_tabCompanions.vue?vue&type=script&lang=js&"
export * from "./_tabCompanions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports